import { Resume } from 'packages/types'
import { SettingsFieldChangeHandler } from '../../../../../modules/resumeEditor'
import { useTemplateCustomization } from './useTemplateCustomization'

type FontSizeFieldIds =
  | 'fontSizePrimaryHeading'
  | 'fontSizeSecondaryHeading'
  | 'fontSizeBody'
  | 'fontSizeSectionTitles'

const FALLBACK_VALUES = {
  fontSizePrimaryHeading: {
    default: 14,
    min: 7,
    max: 21,
    step: 1,
  },
  fontSizeSecondaryHeading: {
    default: 12,
    min: 6,
    max: 18,
    step: 1,
  },
  fontSizeBody: {
    default: 10,
    min: 5,
    max: 15,
    step: 1,
  },
  fontSizeSectionTitles: {
    default: 12,
    min: 6,
    max: 18,
    step: 1,
  },
}

export function useFontSizeField(resume?: Resume, onFieldChange?: SettingsFieldChangeHandler) {
  const { currentTemplate, resumeSpecificTemplateSettings } = useTemplateCustomization(resume)

  const getFontSizeField = (field: FontSizeFieldIds) => {
    const currentValue = resumeSpecificTemplateSettings?.[field]
    const defaultValues = currentTemplate?.settings?.[field]
    const fallbackValues = FALLBACK_VALUES[field]

    return {
      value: currentValue ?? defaultValues?.default ?? fallbackValues.default,
      defaultValue: defaultValues?.default ?? fallbackValues.default,
      min: defaultValues?.min ?? fallbackValues.min,
      max: defaultValues?.max ?? fallbackValues.max,
      step: defaultValues?.step ?? fallbackValues.step,
      onChange: (newValue: number) => {
        onFieldChange?.(field, newValue, defaultValues?.default ?? fallbackValues.default)
      },
    }
  }

  return { getFontSizeField }
}
